import { createEventBus } from "../../Common/eventBusFactory";

export const eventBus = createEventBus();

export const ON_SHOW_CONFLICTS_MODAL = "onShowConflictsModal";

export const ON_SHOW_CONFLICTS_FOR_CATEGORY = "onShowConflictsForCategory";

export const ON_SLICE_TOOL_MODAL_OPENED = "onSliceToolModalOpened";
export const ON_DISTRIBUTE_TOOL_MODAL_OPENED = "onDistributeToolModalOpened";
